// RecordsPage.jsx
import React, { useState, useEffect } from "react";

const getPostId = (post) => post.id || post._id;

export default function RecordsPage() {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState("RECENT");
  const [selectedPost, setSelectedPost] = useState(null);

  useEffect(() => {
    const fetchNFTs = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_API_URL;
        const response = await fetch(`${backendUrl}/api/nfts`);
        const data = await response.json();
        setPosts(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching NFTs:", error);
      }
    };

    fetchNFTs();
  }, []);

  const filterPosts = () => {
    const filtered = posts.filter((p) => p.type === "writtenRecord");

    if (filter === "BRiGHTEST") {
      return [...filtered].sort((a, b) => (b.lights || 0) - (a.lights || 0));
    }

    if (filter === "NEED LiGHT") {
      return [...filtered].sort((a, b) => (a.lights || 0) - (b.lights || 0));
    }

    return filtered;
  };

  const getRemaining = (post) => {
    if (post.remaining !== undefined) {
      return Math.max(Number(post.remaining) || 0, 0);
    }

    return Math.max((Number(post.supply) || 0) - (Number(post.castleAdds) || 0), 0);
  };

  return (
    <div className="min-h-screen bg-brandBlack text-brandWhite p-6">
      <div className="mb-6 text-center">
        <h2 className="text-3xl font-bold">RECORDS</h2>
        <p className="text-lg">📜</p>
      </div>

      <div className="text-center mb-4">
        {["RECENT", "BRiGHTEST", "NEED LiGHT"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`p-2 mx-2 ${filter === f ? "bg-gray-700 text-white" : "bg-gray-400"}`}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filterPosts().map((post) => {
          const id = getPostId(post);
          const remaining = getRemaining(post);

          return (
            <div key={id} className="border border-gray-700 rounded p-4 bg-gray-900">
              <div className="text-center font-gothic text-lg mb-2">
                {post.title || "Untitled Record"}
              </div>

              <div className="text-sm text-gray-300 mb-2">
                {post.description?.slice(0, 100) || "No description"}...
              </div>

              <div className="text-sm text-gray-400 text-center">
                ☉ {post.lights || 0} | + {post.records || 0} | ⛫ {remaining}
              </div>

              {remaining <= 0 ? (
                <div className="text-xs text-red-400 text-center mt-1">SOLD OUT</div>
              ) : null}

              <button
                onClick={() => setSelectedPost(post)}
                className="block mx-auto mt-3 px-4 py-1 bg-gray-700 hover:bg-gray-600 rounded"
              >
                View
              </button>
            </div>
          );
        })}
      </div>

      {selectedPost && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center">
          <div className="bg-gray-900 p-6 rounded w-full max-w-xl">
            <h2 className="text-xl font-bold font-gothic mb-2">
              {selectedPost.title || "Untitled Record"}
            </h2>

            <p className="text-gray-300 mb-4">
              {selectedPost.description || "No description available."}
            </p>

            <div className="text-sm text-gray-400 mb-2">
              ☉ {selectedPost.lights || 0} | + {selectedPost.records || 0} | ⛫ {getRemaining(selectedPost)}
            </div>

            {getRemaining(selectedPost) <= 0 ? (
              <p className="text-red-400 font-bold mb-4">SOLD OUT</p>
            ) : null}

            <button
              onClick={() => setSelectedPost(null)}
              className="block mx-auto mt-4 bg-gray-700 hover:bg-gray-600 px-4 py-2 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}